module.exports = __webpack_public_path__ + "static/Horizon-Regular-a1f52ad9ea984db8c2d6564fcb50f34e.otf";